import { render, staticRenderFns } from "./ModalAddInstructor.vue?vue&type=template&id=6fbc2e3c&scoped=true&"
import script from "./ModalAddInstructor.vue?vue&type=script&lang=js&"
export * from "./ModalAddInstructor.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddInstructor.vue?vue&type=style&index=0&id=6fbc2e3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbc2e3c",
  null
  
)

export default component.exports